import { AppStatus } from '../../core/constants/AppStatus';

// TODO: Replace with something that uses t()
export const APP_STATUSES: Array<string> = Object.values(AppStatus);
